import React, { useState } from "react";
import { Icon } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa6";
import {
  Box,
  Flex,
} from "@chakra-ui/react";

const StarRating = ({ rating, setRating }) => {
  const [hover, setHover] = useState(null);

  return (
    <Flex gap={{base: "12px", sm: "24px"}}>
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;

        return (
          <Box key={index}>
            <input
              type="radio"
              name="rating"
              value={ratingValue}
              style={{ display: "none" }}
            />
            <Icon
              as={FaStar}
              fontSize={{base: 36, sm: 72}}
              color={ratingValue <= (hover || rating) ? "white" : "whiteAlpha.400"}
              onMouseEnter={() => setHover(ratingValue)}
              onMouseLeave={() => setHover(null)}
              onClick={() => setRating(ratingValue)}
              cursor="pointer"
            />
          </Box>
        );
      })}
    </Flex>
  );
};

export default StarRating;